/**
 * Whether an aircraft can still get home.
 *
 * Computed server-side from the same snapshot the map is drawn from, so the
 * panel cannot disagree with the aircraft next to it. Battery percentage is
 * deliberately not the headline: the same charge is comfortable close in and
 * fatal far out, and the margin is the number that tells them apart.
 */

import { api, type ApiResult } from '@/api/client';

export type EnduranceVerdict = 'ok' | 'commit' | 'critical' | 'unknown';

export interface Endurance {
  droneId: string;
  packMah: number;
  verdict: EnduranceVerdict;
  /** Flight time left at the current draw, seconds. Null when unknowable. */
  enduranceS: number | null;
  /** Time to fly home and get down, seconds. */
  homeS: number | null;
  /** endurance − home − reserve. Negative means the reserve is already spent. */
  marginS: number | null;
  /** How much further out it can still go, metres, accounting for the trip back. */
  reachBeyondHomeM: number | null;
  reason: string;
}

export function getEndurance(droneId: string): Promise<ApiResult<Endurance>> {
  return api.get<Endurance>(`/endurance/${encodeURIComponent(droneId)}`, { logged: false });
}
